export default "/images/d9310c5a8d0c9d7bd803fcde23626f4e.avif";